export default "__VITE_ASSET__Dfp78MjA__"